import perms from "@/common/permissions/sale/perms"
import _ from "lodash"

/**
 * @description 外勤模块权限
 * @param loginStatus
 * @returns {*|boolean}
 */
function outside(loginStatus) {
  return loginStatus.oneOf([perms.OUTSIDE_MANAGE]) && _.includes(loginStatus.saleStatus?.grayPermissions, perms.GRAY_IO_MANAGEMENT)
}

/**
 * @description: 企微客户灰度
 */
function onlineSales(loginStatus) {
  return _.includes(loginStatus?.saleStatus?.grayPermissions, perms.GRAY_ONLINE_SALES_AGENCY_BIND)
}

export default {
  outside,
  onlineSales,
}
